<template>
  <div class="mx-4 mt-2 mpc-cluster-config">
    <!-- Account picker -->
    <div class="bar full-width pa-2">
      <v-row
        class="ma-0 cursor-pointer"
        @click.stop="accountPickerOpen = !accountPickerOpen"
      >
        <template v-if="accountPickerOpen">
          <span class="token-text-medium ml-2 my-auto">
            Select an account
          </span>
        </template>
        <template v-else>
          <template v-if="!hasAnyAccountOption">
            <Icon icon="block" class="ml-2 mr-0" />
            <span class="token-text-medium ml-2 my-auto">
              No account selected
            </span>
          </template>
          <template v-else>
            <Logo
              v-if="currentProviderAccount"
              :logo="currentProviderAccount?.provider"
              class="ml-2 mr-0"
            />
            <span class="token-text-medium ml-2 my-auto">
              {{ currentProviderAccount?.name || "Select an account" }}
            </span>
          </template>
        </template>
        <CustomButton
          class="ml-auto my-auto"
          :level="$enums.ButtonLevels.SmallIcon"
        >
          <Icon
            icon="caret-down"
            class="caret"
            :class="{ invert: accountPickerOpen }"
          />
        </CustomButton>
      </v-row>

      <HeightDeployer v-model="accountPickerOpen" class="ma-2">
        <template v-if="!hasAnyAccountOption">
          <v-row class="ma-0 mt-2 token-text-regular">
            You need to connect a {{ providerLabel }} account to continue
          </v-row>
        </template>
        <template v-else>
          <template v-if="hasFransysAccount">
            <RadioListElement
              :selected="selectedInfrastructureProviderAccountId === null"
              class="mt-2"
              @select="selectCustomerAccount(null)"
            >
              <Logo logo="fransys" class="mr-2 ml-0" />
              <span class="token-text-medium my-auto">Fransys account</span>
            </RadioListElement>
          </template>

          <template v-if="customerAccounts.length">
            <v-row
              class="ma-0 token-text-regular token-text-color-secondary"
              :class="{ 'mt-4': hasFransysAccount }"
            >
              Use your own account
            </v-row>
            <RadioListElement
              v-for="account of customerAccounts"
              :key="account.id"
              :selected="selectedInfrastructureProviderAccountId === account.id"
              class="mt-2"
              @select="selectCustomerAccount(account.id)"
            >
              <Logo :logo="account.provider" class="mr-2 ml-0" />
              <span class="token-text-medium">{{ account.name }}</span>
            </RadioListElement>
          </template>
        </template>
        <v-row
          class="ma-0 mt-4 token-text-medium token-text-color-secondary account-link"
          @click="$emit('connectAccount')"
        >
          Connect another account
        </v-row>
      </HeightDeployer>
    </div>
    <!-- / Account picker -->
    <!-- <v-row
      v-if="!accountPickerOpen"
      class="ma-0 mb-4 account-summary-row"
      @click.stop="accountPickerOpen = true"
    >
      <v-col class="pa-0 d-flex">
        <Icon icon="user" class="mr-2" />
        <span class="token-text-medium">{{ selectedAccountLabel }}</span>
        <span
          class="ml-1 token-text-regular token-text-color-secondary"
          v-if="selectedInfrastructureProviderAccountId !== undefined"
          >selected</span
        >
        <Icon class="ml-auto" icon="arrow-right" />
      </v-col>
    </v-row>

    <v-row v-else class="ma-0 mb-4 card account-selection-card" @click.stop>
      <v-col class="pa-3">
        <v-row class="ma-0 account-header-row">
          <Icon icon="user" class="mr-2" />
          Account
          <CustomButton
            class="ml-auto"
            :level="$enums.ButtonLevels.SmallIcon"
            @click.stop="accountPickerOpen = false"
          >
            <Icon icon="caret-down" />
          </CustomButton>
        </v-row>

        <template v-if="!hasAnyAccountOption">
          <v-row class="ma-0 mt-2 account-option disabled">
            <Icon icon="user" class="mr-2" />
            No account selected
          </v-row>
          <v-row class="ma-0 mt-4 token-text-regular account-empty-text">
            You need to connect a {{ providerLabel }} account to continue
          </v-row>
          <v-row
            class="ma-0 mt-2 token-text-medium token-text-color-secondary account-link"
            @click="$emit('connectAccount')"
          >
            Connect an account
          </v-row>
        </template>
        <template v-else>
          <template v-if="hasFransysAccount">
            <v-row
              class="ma-0 mt-2 account-option"
              :class="{
                selected:
                  selectedInfrastructureProviderAccountId === null,
              }"
              @click.stop="selectFransysAccount"
            >
              <span class="token-text-medium">Fransys account</span>
              <span
                class="ml-auto radio-indicator"
                :class="{
                  selected:
                    selectedInfrastructureProviderAccountId === null,
                }"
              />
            </v-row>
          </template>

          <template v-if="customerAccounts.length">
            <v-row
              class="ma-0 mt-4 token-text-regular token-text-color-secondary"
            >
              Use your own account
            </v-row>
            <v-row
              v-for="account of customerAccounts"
              :key="account.id"
              class="ma-0 mt-2 account-option"
              :class="{
                selected:
                  selectedInfrastructureProviderAccountId === account.id,
              }"
              @click.stop="selectCustomerAccount(account.id)"
            >
              <Logo
                v-if="providerLogo"
                :logo="providerLogo"
                class="mr-2 ml-0"
              />
              <span class="token-text-medium">{{ account.name }}</span>
              <span
                class="ml-auto radio-indicator"
                :class="{
                  selected:
                    selectedInfrastructureProviderAccountId ===
                    account.id,
                }"
              />
            </v-row>
          </template>

          <v-row
            class="ma-0 mt-3 token-text-medium token-text-color-secondary account-link"
            @click="$emit('connectAccount')"
          >
            Connect another account
          </v-row>
        </template>
      </v-col>
    </v-row> -->

    <!-- First row -->
    <v-row class="ma-0">
      <v-col class="pa-0 d-flex">
        <v-row class="ma-0 my-2 mx-auto fit-content">
          <div
            :class="'token-text-medium' + (!internalIsAutoPilot ? 'bold' : '')"
          >
            Manual
          </div>
          <div class="mx-2">
            <Switch
              v-model="internalIsAutoPilot"
              @change="$emit('update:isAutoPilot', internalIsAutoPilot)"
            />
          </div>
          <div
            :class="'token-text-medium' + (internalIsAutoPilot ? 'bold' : '')"
          >
            AutoPilot
          </div>
        </v-row>
      </v-col>
    </v-row>
    <!-- / First row -->

    <!-- Second row : AutoPilot -->
    <v-row
      v-if="internalIsAutoPilot && !nodePoolList.length"
      class="ma-0 mb-2 card"
    >
      <v-col class="pa-0 mr-1">
        <v-row
          class="ma-0 bg-gradiant-autopilot rounded-border token-text-regular pa-2"
        >
          <v-col class="pa-0 d-flex-col">
            <v-img
              src="@/assets/illustrations/autopilot.svg"
              height="40px"
              width="40px"
              class="mx-auto my-2"
            />
            <div class="mx-auto">Autopilot mode activated</div>
          </v-col>
        </v-row>
        <v-row class="ma-0 pa-2">
          <v-col class="pa-0 my-auto token-text-regular">
            Monthly maximum budget
          </v-col>
          <v-col class="pa-0 my-auto">
            <CustomNumberInput
              v-model="internalMaxBudget"
              :min="minBudget"
              @update:modelValue="$emit('update:maxBudget', $event)"
            />
          </v-col>
          <v-col class="pa-0 fit-content ml-2 my-auto token-text-regular">
            {{ $enums.CurrencyTrigramToSymbol[currency] }}
          </v-col>
        </v-row>
        <v-row v-if="!nodePoolList.length" class="ma-0 pa-2">
          <Message :severity="$enums.Severity.INFO">
            <template #title> Your cluster is ready </template>
            <template #text>
              Your cluster is already fully configured, and you can deploy it as
              is.<br />
              You can specify which typologies of node you want to use by adding
              node pools.<br />
            </template>
          </Message>

          <CustomButton
            :level="$enums.ButtonLevels.Secondary"
            icon="edit"
            text="Edit node pool"
            class="mt-2 full-width"
            @click="$emit('goToAddNodePool')"
          />
        </v-row>
      </v-col>
    </v-row>
    <!-- / Second row -->

    <!-- Third row : node pools -->
    <v-row v-if="errorMsg" class="ma-0 mt-2">
      <Message
        title="Not enought nodes"
        :severity="$enums.Severity.DANGER"
        :text="errorMsg"
      />
    </v-row>
    <v-row v-if="nodePoolList.length || !internalIsAutoPilot" class="ma-0">
      <v-col class="pa-0">
        <v-row class="ma-0 mb-2">
          <div class="d-flex">
            <span class="token-text-h5"> Node pools </span>
            <!-- Nb master nodes -->
            <template v-if="internalIsAutoPilot">
              <span
                v-if="nbMasterNodes.min > 0 || nbMasterNodes.max > 0"
                class="token-text-regular my-auto token-text-color-secondary d-flex ml-2"
              >
                + {{ nbMasterNodes.min }}
                <template v-if="nbMasterNodes.min !== nbMasterNodes.max">
                  <Icon icon="arrow-right" class="mx-2" />
                  {{ nbMasterNodes.max }}
                </template>
                master nodes
                <Tooltip
                  class="ml-1"
                  docLink="guides/cluster-configuration/#defining-the-number-of-nodes"
                >
                  <template #header> Control nodes are added </template>
                  <template #content>
                    Starting at 2 nodes, we add dedicated nodes to manage the
                    workload on your cluster.<br />
                    They are added to improve reliability and stability and
                    while fully managed by Fransys, they increase the overall
                    cost of your cluster.
                  </template>
                </Tooltip>
              </span>
            </template>
            <template v-else>
              <span
                v-if="nbMasterNodes.min > 0"
                class="token-text-regular token-text-color-secondary"
              >
                + {{ nbMasterNodes.min }} master nodes
              </span>
            </template>
            <!-- / Nb master nodes -->
          </div>
          <CustomButton
            class="ml-auto my-auto"
            :level="$enums.ButtonLevels.SmallIcon"
            @click="nodePoolDeployed = !nodePoolDeployed"
          >
            <Icon
              icon="caret-down"
              class="caret"
              :class="{ invert: nodePoolDeployed }"
            />
          </CustomButton>
        </v-row>
        <v-row class="ma-0 mx-n4">
          <HeightDeployer v-model="nodePoolDeployed" class="full-width">
            <v-col class="pa-0">
              <v-row
                v-for="(nodePool, index) in nodePoolList"
                :key="'node-pool-' + index"
                class="ma-0 mx-4 card-typo pa-2 mb-2"
              >
                <v-col
                  v-for="(fullTypologie, index2) of [
                    getFullTypologie(nodePool.typology),
                  ]"
                  :key="'fullTypologie-' + index + '-' + index2"
                  class="fit-content"
                >
                  <template v-if="fullTypologie">
                    <v-row
                      class="ma-0 token-text-color-primary token-text-redular"
                    >
                      {{ fullTypologie?.attributes.name }}
                    </v-row>
                    <v-row
                      class="ma-0 token-text-color-primary token-text-redular"
                    >
                      <span class="token-text-regularbold">
                        {{
                          $helpers.prices.format(
                            Number(fullTypologie?.attributes.price.amount),
                            fullTypologie?.attributes.price.currency,
                          )
                        }}
                      </span>
                      <span class="ml-1"> / node </span>
                    </v-row>
                    <v-row
                      class="ma-0 token-text-color-primary token-text-redular"
                    >
                      <v-col class="pa-0 fit-content mr-2">
                        <v-row class="ma-0">
                          {{ fullTypologie?.attributes.cores }}
                          <Icon icon="chip" class="ml-1" />
                        </v-row>
                      </v-col>
                      <v-col class="pa-0 fit-content mr-2">
                        <v-row class="ma-0">
                          {{ fullTypologie?.attributes.memory }}
                          <Icon icon="ram" class="ml-1" />
                        </v-row>
                      </v-col>
                      <v-col class="pa-0 fit-content">
                        <v-row class="ma-0">
                          {{ fullTypologie?.attributes.gpus.length }}
                          <Icon icon="gpu" class="ml-1" />
                        </v-row>
                      </v-col>
                    </v-row>
                  </template>
                </v-col>
                <v-col class="pa-0 d-flex">
                  <div class="my-auto full-width">
                    <Slider
                      v-if="!internalIsAutoPilot"
                      :value="nodePool.target_size"
                      :step="1"
                      :min="0"
                      :max="nbMaxNodePerPool"
                      :range="false"
                      @updateValue:value="updateNodePoolSize(nodePool, $event)"
                    >
                      <template #thumb-label="{ modelValue }">
                        <span class="token-text-mediumbold">
                          {{ modelValue }}
                        </span>
                      </template>
                    </Slider>
                    <Slider
                      v-else
                      :values="[nodePool.min_size, nodePool.max_size]"
                      :step="1"
                      :min="0"
                      :max="nbMaxNodePerPool"
                      :range="true"
                      class="pt-12"
                      @updateValue:values="
                        updateNodePoolSize(nodePool, $event[0], $event[1])
                      "
                    >
                      <template #thumb-label="{ modelValue }">
                        <v-col class="pa-0 d-flex-col px-1">
                          <span class="mx-auto token-text-pico">
                            {{
                              modelValue === nodePool.min_size ? "Min" : "Max"
                            }}
                          </span>
                          <span class="mx-auto token-text-mediumbold">
                            {{ modelValue }}
                          </span>
                        </v-col>
                      </template>
                    </Slider>
                  </div>
                </v-col>
                <v-col class="pa-0 d-flex fit-content">
                  <CustomButton
                    class="ml-auto my-auto"
                    :level="$enums.ButtonLevels.SmallIcon"
                    icon="trash"
                    iconColor="#E15F19"
                    @click="$emit('deleteNodePool', index)"
                  />
                </v-col>
              </v-row>
              <v-row class="ma-0 token-background-color-secondary mx-n4 mt-2">
                <CustomButton
                  :level="$enums.ButtonLevels.Secondary"
                  icon="add"
                  text="Add node pool"
                  class="my-2 ml-8"
                  :style="{ width: 'calc(100% - 64px)' }"
                  @click="$emit('goToAddNodePool')"
                />
              </v-row>
            </v-col>
          </HeightDeployer>
        </v-row>
      </v-col>
    </v-row>
    <!-- Third row : node pools -->
  </div>
</template>

<script lang="ts">
import { Vue, Options, prop } from "vue-class-component";
import { Watch } from "vue-property-decorator";
import {
  APIClusterLocation,
  APIClusterNodeTypologie,
  APIClusterRequirement,
} from "@/typesAPI";
import { NodePool } from "@/types";

import CustomButton from "@/components/UIElements/CustomButton.vue";
import Switch from "@/components/UIElements/Switch.vue";
import RadioListElement from "@/components/UIElements/RadioList/RadioListElement.vue";
import HeightDeployer from "@/components/UIElements/HeightDeployer.vue";
import Icon from "@/components/UIElements/Icon.vue";
import Logo from "@/components/UIElements/Logo.vue";
import Slider from "@/components/UIElements/Slider.vue";
import CustomNumberInput from "@/components/UIElements/CustomNumberInput.vue";
import Tooltip from "@/components/UIElements/Tooltip.vue";
import Message from "@/components/UIElements/Message.vue";

type ClusterAccountOption = {
  id: string;
  name: string;
  provider: string;
};

const fransysAccountOption: ClusterAccountOption = {
  id: "fransys",
  name: "Fransys account",
  provider: "fransys",
};

class Props {
  location: APIClusterLocation = prop({
    required: true,
  });
  provider: string = prop({
    required: true,
  });
  nodePoolList: NodePool[] = prop({
    required: true,
  });
  isAutoPilot: boolean = prop({
    required: true,
  });
  safety: number = prop({
    required: true,
  });
  maxBudget: number = prop({
    required: true,
  });
  nbMasterNodes: {
    min: number;
    max: number;
  } = prop({
    required: true,
  });
  errorMsg?: string = prop({
    required: false,
  });
  hasFransysAccount: boolean = prop({
    required: true,
  });
  customerAccounts: ClusterAccountOption[] = prop({
    required: true,
  });
  selectedInfrastructureProviderAccountId: string | null = prop({
    required: true,
  });
  providerLabel: string = prop({
    required: true,
  });
}

@Options({
  components: {
    CustomButton,
    Switch,
    RadioListElement,
    HeightDeployer,
    Icon,
    Logo,
    Slider,
    CustomNumberInput,
    Tooltip,
    Message,
  },
})
export default class MPCClusterConfig extends Vue.with(Props) {
  internalIsAutoPilot = true;
  nodePoolDeployed = true;
  internalMaxBudget = 0;
  internalSafety = 0;
  nbMaxNodePerPool = 20;
  minBudget = 25;
  accountPickerOpen = false;

  get hasAnyAccountOption(): boolean {
    return this.hasFransysAccount || this.customerAccounts.length > 0;
  }

  get selectedAccountLabel(): string {
    if (this.selectedInfrastructureProviderAccountId === null) {
      return "Fransys account";
    }
    if (typeof this.selectedInfrastructureProviderAccountId === "string") {
      const account = this.customerAccounts.find(
        (acc: ClusterAccountOption) =>
          acc.id === this.selectedInfrastructureProviderAccountId,
      );
      if (account) {
        return account.name;
      }
    }
    return "No account selected";
  }

  selectCustomerAccount(accountId: string | null) {
    this.$emit("update:selectedInfrastructureProviderAccountId", accountId);
  }

  get currentProviderAccount() {
    if (this.selectedInfrastructureProviderAccountId === null) {
      if (this.hasFransysAccount) {
        return fransysAccountOption;
      } else if (this.customerAccounts.length > 0) {
        return this.customerAccounts[0];
      } else {
        return null;
      }
    } else {
      return (
        this.customerAccounts.find(
          (acc: ClusterAccountOption) =>
            acc.id === this.selectedInfrastructureProviderAccountId,
        ) || null
      );
    }
  }

  get nodeTypologies(): APIClusterNodeTypologie[] {
    if (!this.provider) {
      return [];
    }
    return this.$store.getters[
      "clusters/getClusterNodeTypologiesByProviderAndLocation"
    ](this.provider, this.location?.id);
  }

  get currency(): string {
    return this.$store.getters["user/getCurrency"];
  }

  get providerRequirements(): APIClusterRequirement[] {
    if (!this.location) {
      return [];
    }
    return this.$store.getters[
      "clusters/getClusterRequirementsByProviderAndLocation"
    ](this.provider, this.location?.id);
  }

  getFullTypologie(typologyId: string): APIClusterNodeTypologie | null {
    return (
      this.nodeTypologies.find(
        (typology: APIClusterNodeTypologie) => typology.id === typologyId,
      ) || null
    );
  }

  updateNodePoolSize(nodePool: NodePool, minSize: number, maxSize?: number) {
    if (maxSize !== undefined) {
      nodePool.min_size = minSize;
      nodePool.max_size = maxSize;
    } else {
      nodePool.target_size = minSize;
    }
  }

  @Watch("isAutoPilot", { immediate: true })
  onIsAutoPilotChange(newVal: boolean) {
    if (newVal !== this.internalIsAutoPilot) {
      this.internalIsAutoPilot = newVal;
    }
  }

  @Watch("maxBudget", { immediate: true })
  onMaxBudgetChange(newVal: number) {
    if (newVal !== this.internalMaxBudget) {
      this.internalMaxBudget = newVal;
    }
  }

  @Watch("safety", { immediate: true })
  onSafetyChange(newVal: number) {
    if (newVal !== this.internalSafety) {
      this.internalSafety = newVal;
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/css/variables";
.mpc-cluster-config {
  max-width: 600px;
}

.caret {
  transition: transform 0.2s ease-in-out;
  &.invert {
    transform: rotate(-180deg);
  }
}
.card-typo {
  border: 1px solid $color-neutral-grey-12;
  border-radius: 8px;
}

.account-link {
  text-decoration: underline;
  cursor: pointer;
  width: fit-content;
}
</style>
